import { useMemo } from "react";
import { ChartConfig } from "../components/chartV2/chart.typings";
import { WidgetDashboardConfig } from "../components/widgetDashboard/widgetDashboard.interface";

export const useChartConfigs = (activeLayoutId: string, activeLayout: WidgetDashboardConfig, configs: Record<string, ChartConfig>) => {
    return useMemo(() => {
      const chartIds = Object.entries(activeLayout?.widgets ?? {}).reduce((acc, [widgetKey, widget]) => {
        const chartId = `${activeLayoutId}-${widget.slotId}`;
        acc[chartId] = configs[chartId];
        return acc;
      }, {} as Record<string, ChartConfig>);
  
      return chartIds;
    }, [activeLayout, configs, activeLayoutId]); 
};